export var TabTypes;
(function (TabTypes) {
    TabTypes[TabTypes["PlainCalendar"] = 0] = "PlainCalendar";
    TabTypes[TabTypes["PriceGraph"] = 1] = "PriceGraph";
    TabTypes[TabTypes["RoundtripMatrix"] = 2] = "RoundtripMatrix";
})(TabTypes || (TabTypes = {}));
